<template>
  <img alt="Cargando" class="w-24 h-24 mx-auto" src="/images/loading.svg" v-if="viewReady == 'loading'">
  <div class="py-4 text-white bg-red-500 text-center leading-none" v-else-if="viewReady == 'error'">
    <p class="font-bold mb-2">⚠️ Algo no está bien</p>
    <p class="text-sm">Lo sentimos, pero ocurrió algo extraño y no pudimos cargar tu carrito.<br>Por favor, intenta nuevamente.</p>
  </div>
  <div v-else id="summary-holder">
    <div class="rounded p-4 mb-4 bg-gray-100 leading-tight">
      <p class="font-bold mb-1">¿Tienes un cupón?</p>
      <div class="flex flex-row items-center">
        <div class="flex-1 mr-2">
          <input type="text" class="form-input text-sm" v-model="coupon" placeholder="Ingrésalo aquí" name="coupon">
        </div>
        <div class="flex-none"><button class="bt main text-xs" type="button" @click="loadProducts()">Aplicar</button></div>
      </div>
      <div class="text-xs mt-2 text-green-500" v-if="couponMessage == true">Cupón aplicado con éxito.</div>
      <div class="text-xs mt-2 text-main" v-if="couponMessage == false">Cupón inválido.</div>
    </div>
    <table class="bordered-table text-sm w-full leading-tight mb-4">
      <tr>
        <td class="font-bold" colspan="2">Producto</td>
        <td class="font-bold text-center">Cantidad</td>
        <td class="font-bold text-center">Precio unitario</td>
        <td class="font-bold text-center">Envío</td>
        <td class="font-bold text-right">Subtotal</td>
      </tr>

      <tbody :key="`product-${i}`" v-for="(product, i) in products" class="border-b border-gray-500 product-detail">
        <tr>
          <td width="20%" class="w-12 pr-2"><a :href="`/productos/${product.slug}`" target="_blank"><img :src="product.image == null ? '/images/placeholder-product-thumb.jpg' : product.image.thumb_url" :alt="product.name"></a></td>
          <td width="20%" ><a :href="`/productos/${product.slug}`" target="_blank" class="link-basic font-bold">{{ product.name }}</a></td>
          <td width="15%" class="text-center">
            <select
              class="form-input w-4 mx-auto"
              v-model="product.quantity"
              @change="updateProduct(product.slug, $event)">
              <option :key="`prod-${product.slug}-qty-${i}`" :value="i" v-for="i in product.max_quantity">{{ i }}</option>
            </select>
          </td>
          <td width="15%" class="text-center">
            <p>C${{ product.unit_price_formated }}</p>
            <p class="mt-1 text-gray-700 text-xs" v-if="product.bonus > 0">- BONO C${{ product.bonus_formated }}</p>
            <p class="mt-1 text-gray-700 text-xs" v-if="product.has_cesc">+ (CESC) C${{ product.cesc_formated }}</p>
          </td>
          <td width="10%" class="text-right">{{ product.route_cost ? 'C$'+product.route_cost : 'N/A' }}</td>
          <td width="20%" class="text-right">C${{ Number(( Number(product.subtotal) + Number ((product.route_cost ? product.route_cost : 0)) ).toFixed(2)).toLocaleString() }}</td>
        </tr>
        <tr>
          <td colspan="7" class="text-right"><button type="button" class="bt clear text-xs remove-product-bt" @click="removeProduct(product.slug)">Eliminar</button></td>
        </tr>
      </tbody>

      <tbody v-if="royalties.length > 0" class="border-b border-gray-500">
        <tr :key="`royalty-${i}`" v-for="(product, i) in royalties">
          <td class="w-12 pr-2"><a :href="`/productos/${product.slug}`" target="_blank"><img :src="product.image == null ? '/images/placeholder-product-thumb.jpg' : product.image.url" :alt="product.name"></a></td>
          <td><a :href="`/productos/${product.slug}`" target="_blank" class="link-basic font-bold">{{ product.name }}</a></td>
          <td></td>
          <td class="text-center"></td>
          <td class="text-right font-bold">GRATIS</td>
        </tr>
      </tbody>

      <tbody class="border-b border-gray-500" v-if="showShippingMethods">
        <tr>
          <td class="font-bold" colspan="7" style="padding-top:0.86rem">Métodos de envío</td>
        </tr>
        <tr :key="`sm-${i}`" v-for="(method, i) in shippingMethods">
          <td colspan="5"><label class="cursor-pointer" @click="selectShippingMethod(method.price)"><input type="radio" :value="method.id" name="shipping_method_id" required v-model="selectedShipingMethodId" class="shipping-method-radio"> {{ method.name }}</label></td>
          <td class="text-right">C${{ method.price_formated }}</td>
        </tr>
      </tbody>

      <tr>
        <td colspan="5" class="font-bold text-lg" style="padding-top:0.86rem">Total</td>
        <td class="font-bold text-lg text-right">C${{ numberFormat(cartTotal + selectedShipingMethodCost + routeTotal) }}</td>
      </tr>
      <tr v-if="payments > 1">
        <td colspan="5">{{ payments }} cuotas de aproximadamente</td>
        <td class="text-right">C${{ numberFormat((cartTotal + selectedShipingMethodCost + routeTotal) / payments) }}</td>
      </tr>
    </table>
    <input type="hidden" name="order_products" v-model="orderProducts">
    <div class="text-center text-sm" >
      <button type="button" @click="generatePdfLink()" class="bt clear">Imprimir</button>
    </div>
    <div class="text-white px-6 py-4 border-0 rounded relative mb-4 mt-4 bg-red-500 text-sm" v-if="productsNotApplyToCity.length > 0">
      <span class="inline-block align-middle mr-8">{{ messageNotDelivery }}</span>
          <ul class="list-disc ml-5" id="products-not-apply">
            <li :key="`product-${i}`" v-for="(product, i) in productsNotApplyToCity" >{{ product.name }}</li>
          </ul>
          <label v-if="forcedMultiple">
            <input @change="forceMultipleDelivery()" type="checkbox" name="forceDelivery" id="forceDelivery" value="1" class="mt-5 form-tick h-4 w-4 border border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none" >
            <span class="text-white font-medium">Solicitar retiro en tienda de {{ productsNotApplyToCity.length }} producto{{ productsNotApplyToCity.length>1? 's' : '' }}</span>
          </label>
          <label v-if="forcedShipping">
            <input @change="forceShippingDelivery()" type="checkbox" name="forceDelivery" id="forceDelivery" value="1" class="mt-5 form-tick h-4 w-4 border border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none" >
            <span class="text-white font-medium">Solicitar despacho a domicilio.</span>
          </label>
          <label v-if="forcedPickup">
            <input @change="forcePickupDelivery()" type="checkbox" name="forceDelivery" id="forceDelivery" value="1" class="mt-5 form-tick h-4 w-4 border border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none" >
            <span class="text-white font-medium">Solicitar retiro en tienda</span>
            <p class="text-center mt-2"><a href="/zonas-de-cobertura">Ver zonas de cobertura</a></p>
          </label>
    </div>
  </div>
</template>

<script>
import { globalEventBus } from '../../_globalEventBus';
export default {
  name: 'checkout-summary',
  data() {
    return {
      forcedMultiple: false,
      forcedShipping: false,
      forcedPickup: false,
      messageNotDelivery : 'NOT',
      viewReady: 'loading',
      products: [],
      productsNotApply: [],
      royalties: [],
      cartTotal: 0,
      cartTotalFormated: '0',
      routeTotal: 0,
      orderProducts: '',
      resourcesLoaded: 0,
      shippingMethods: [],
      productsNotApplyToCity: [],
      selectedUserCity: 0,
      selectedShipingMethodCost: 0,
      showShippingMethods: false,
      payments: 1,
      ccNumber: '',
      coupon: '',
      dispatchTypes: [],
      typeSend: 'SHIPPING',
      couponMessage: null,
      forceMultiple: false
    }
  },
  mounted() {

    this.loadProducts();
    this.loadShippingMethods();

    // Global event bus
    globalEventBus.$on('dispatchTypeUpdated', params => {
      this.dispatchTypes[params] = params;

      this.typeSend = params;
      this.selectedShipingMethodCost = 0;
      this.selectedShipingMethodId = null;
      this.validateShipping();
    });

    globalEventBus.$on('cityValueUpdated', params => {
      this.selectedUserCity = params;
      this.loadProducts();
    });

    globalEventBus.$on('paymentMethodUpdated', method => {
      if (method.payments != null) {
        this.payments = parseInt(method.payments[0]);
      } else {
        this.payments = 1;
      }
    });

    globalEventBus.$on('paymentsUpdated', payments => {
      this.payments = parseInt(payments);
    });

    globalEventBus.$on('ccNumberUpdated', ccNumber => {
      this.ccNumber = ccNumber;

      this.viewReady = 'loading';
      this.resourcesLoaded--;

      this.loadProducts();
    });
  },
  methods: {
    resourceLoaded() {
      this.resourcesLoaded++;
      if (this.resourcesLoaded == 2) {
        this.viewReady = 'ready';
      }
    },
    loadProducts: async function() {
      try {
        let res = await axios.post('/carrito/resumen', { cc: this.ccNumber, coupon: this.coupon, city:this.selectedUserCity });
        let { data } = await res.data;
        this.resourceLoaded();
        //this.loadProducts();
        this.updateSummary(data);

        globalEventBus.$emit('ccAppliesBankPromo', data.bank_promo);
        this.couponMessage = null;
        if (this.coupon != '') {
          this.couponMessage = data.coupon_promo;
        }

        this.showProductsNotApply(data);

      } catch(e) {
        this.viewReady = 'error';
      }
    },
    loadShippingMethods: async function() {
      try {
        let res = await axios.post('/carrito/metodos-de-envio');
        let { data } = await res.data;
        this.shippingMethods = data;

        if (data.length > 0) {
          this.selectedShipingMethodId = data[0].id;
          this.selectShippingMethod(data[0].price);
        }

        this.resourceLoaded();
      } catch(e) {
        this.viewReady = 'error';
      }
    },
    updateProduct(slug, event) {
      this.viewReady = 'loading';
      this.products = [];
      axios.put(
        '/carrito/actualizar-producto',
        {product: slug, quantity: event.target.value,city:this.selectedUserCity},
        { headers: { 'Content-Type': 'application/json', } }
      ).then(response => {
        this.updateSummary(response.data.data);
        this.validateShipping();
        this.showProductsNotApply( response.data.data );
      })
      .catch(error => {
        this.viewReady = 'error';
      });
    },
    removeProduct(slug) {
      this.viewReady = 'loading';
      this.products = [];
      axios.delete(
        '/carrito/eliminar-producto',
        {data: {product: slug,city:this.selectedUserCity}},
        { headers: { 'Content-Type': 'application/json', } }
      ).then(response => {
        this.updateSummary(response.data.data);
        this.validateShipping();
        this.showProductsNotApply( response.data.data );
      })
      .catch(error => {
        this.viewReady = 'error';
      });
    },
    showProductsNotApply( data ){

      this.routeTotal = 0;
      this.forcedMultiple = false;
      this.forcedShipping = false;
      this.forcedPickup = false;
      var UserSelect = document.getElementById('shipping_city_id');

      if( UserSelect ){

        var UserSelectText = UserSelect.options[UserSelect.selectedIndex].text;

        if (UserSelectText && UserSelect.value!=""){
          this.productsNotApplyToCity = [];
          this.selectedShipingMethodCost = 0;
          data.products.forEach(prod => {

            if( !prod.route_cost){
              console.log(prod);
              this.productsNotApplyToCity.push(prod);
            }else{
              this.routeTotal += Number(prod.route_cost);
              //this.selectedShipingMethodCost += Number(prod.route_cost);
            }
          });

          // Custom messages
            if (this.productsNotApplyToCity.length==data.products.length) {
              this.messageNotDelivery = "Los productos seleccionados no estan disponibles para entrega en "+UserSelectText+". Seleccione una tienda donde desea retirarlos.";
              this.forcedPickup = true;
            }else{
              this.messageNotDelivery = "Algunos productos no aplican para despacho a domicilio, por favor seleccione ambas formas de entrega.";
              this.forcedMultiple = true;
            }

        } else{
          this.productsNotApplyToCity = [];
        }
      } else{
        this.productsNotApplyToCity = [];
      }
    },
    forceMultipleDelivery (){
      let forceDeliveryChecked = document.querySelector('#forceDelivery:checked');
      setTimeout(function(){
        if (forceDeliveryChecked !== null) {
          let info = [1,true];
          globalEventBus.$emit('forceDeliveryType',info);
          info = [0,true];
          globalEventBus.$emit('forceDeliveryType',info);
        }
      },100);
    },
    forceShippingDelivery (){
      let forceDeliveryChecked = document.querySelector('#forceDelivery:checked');
      setTimeout(function(){
        if (forceDeliveryChecked !== null) {
          let info = [1,false];
          globalEventBus.$emit('forceDeliveryType',info);
          info = [0,true];
          globalEventBus.$emit('forceDeliveryType',info);
        }
      },100);
    },
    forcePickupDelivery (){
      let forceDeliveryChecked = document.querySelector('#forceDelivery:checked');
      setTimeout(function(){
        if (forceDeliveryChecked !== null) {
          let info = [1,true];
          globalEventBus.$emit('forceDeliveryType',info);
          info = [0,false];
          globalEventBus.$emit('forceDeliveryType',info);
        }
      },100);
    },
    updateSummary(responseData) {
      if (responseData.products.length == 0) {
        window.location = '/carrito';
        return false;
      }

      this.royalties = responseData.royalties;
      this.products = responseData.products;
      this.cartTotal = responseData.cart_total;
      this.cartTotalFormated = responseData.cart_total_formated;
      this.orderProducts = responseData.summary;

      globalEventBus.$emit('ccAppliesBankPromo', responseData.bank_promo);
      globalEventBus.$emit('paymentMethodsUpdated', responseData.payment_methods);

      document.getElementById('header-cart-counter').innerHTML = responseData.products_count;
      this.validateShipping();

      this.viewReady = 'ready';
    },
    selectShippingMethod(newPrice) {
      //this.selectedShipingMethodCost = newPrice;
    },
    numberFormat(number, includeDecimals = true) {
      let parts = (number).toFixed(2).toString().split(".");
      let integer = parts[0];
      let decimalsPart = (parts[1] == undefined) ? '00' : parts[1];

      if (decimalsPart.length == 1) {
        decimalsPart += 0;
      }

      let output = String(integer).split("").reverse().join("").replace(/(\d{3}\B)/g, "$1,").split("").reverse().join("");

      if (includeDecimals) {
        output += '.' + decimalsPart;
      }

      return output;
    },
    validateShipping(){

      this.showShippingMethods = false;

      if( this.typeSend=='SHIPPING'){
        let data = this.shippingMethods;
        this.selectedShipingMethodId = data[0].id;
      }else{
        this.selectedShipingMethodCost = 0;
        this.selectedShipingMethodId = null;
      }
    },
    generatePdfLink() {
      axios.post(
        '/carrito/cotizacion/generar',
        { cc: this.ccNumber, shipping: this.selectedShipingMethodCost}
      ).then(response => {
        window.open(response.data.data.link, '_blank').focus();
      })
      .catch(error => {
        alert('Lo sentimos, no pudimos generar el archivo de descarga');
      });
    }
  },
}
</script>
